module.exports = __webpack_public_path__ + "static/media/start-button.4f82dee0.png";